import { LoaderFunction } from 'react-router-dom';
import { map, Observable, of, switchMap, take } from 'rxjs';
import { responseHandler } from '../../../../shared/responseHandler/responseHandler';
import { automationService, ListTasksRes } from '../services/automation.service';
import { ListWa_AutomationTasksQueryVariables } from '../../../../graphql/generatedModel';
import { automationLoadingService } from '../services/loading.service';

export const automationLoader: LoaderFunction = async (): Promise<IAutomationLoaderData> => {
  const getList = ({ queryVariables, list }: IGetPaginatedListParams): Observable<any> => {
    const sub = automationService.sub.listTasks().pipe(
      take(1),
      responseHandler<ListTasksRes>({
        errorReturnType: { items: [], cursors: { hasNext: false, after: null } },
      }),
      switchMap((res) => {
        const { hasNext, after } = res.cursors;
        if (hasNext && after) {
          return getList({
            queryVariables: {
              ...queryVariables,
              cursors: { ...(queryVariables?.cursors || {}), after },
            },
            list: [...list, ...res.items],
          });
        }

        return of(res);
      }),
      map((res) => ({ ...res, items: [...list, ...res.items] })),
    );

    automationService.pub.listTasks(queryVariables);
    return sub;
  };

  const initTasksList = await automationService.globHelpers.streamToPromise(
    getList({ list: [] }).pipe(map((res) => res.items)),
    () => automationService.pub.listTasks(),
  );

  automationLoadingService.pub.loading(false);
  return { initTasksList };
};

interface IGetPaginatedListParams {
  queryVariables?: ListWa_AutomationTasksQueryVariables;
  list: ListTasksRes['items'];
}
export interface IAutomationLoaderData {
  initTasksList: ListTasksRes['items'];
}
